import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ImageModule } from 'primeng/image';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { SplitButtonModule } from 'primeng/splitbutton';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'app-main-menu',
  standalone: true,
  imports: [
    MenubarModule,
    ImageModule,
    InputTextModule,
    SplitButtonModule,
    CommonModule,
    ButtonModule,
    RouterLink,
    RouterLinkActive,
    MenuModule
  ],
  templateUrl: './main-menu.component.html',
  styleUrl: './main-menu.component.scss',
})
export class MainMenuComponent implements OnInit {
  userLoggedOptions: any[] = [];
  mobileMenuOpen: boolean = false;

  items?: any;
  menuRol: MenuItem[] = [];

  @Input({ required: true })
  userRoles: any[] = [];

  @Input({required:true})
  isLogged:boolean = false;

  userName: string = '';

  @Output()
  loginRequest: EventEmitter<boolean> = new EventEmitter();

  constructor(private msalService: MsalService) {}

  ngOnInit(): void {

    if(this.isLogged){
      this.buildMenu();
      this.loadMenuByUserRole();
      this.userName =
        this.msalService.instance.getActiveAccount()?.idTokenClaims?.name || '';
    }
  }

  buildMenu() {
    this.items = {
      [environment.roles.gestionRole]: {
        label: 'Gestión Vinculaciones',	
        icon: 'pi pi-fw pi-id-card',
        routerLink: '/gestor',
        items: [
          {
            label: 'Solicitudes',
            icon: 'pi pi-fw pi-inbox',
            routerLink: '/gestor/solicitudes',
          },
          {
            label: 'Vinculaciones',
            icon: 'pi pi-fw pi-user-plus',
            routerLink: '/gestor/vinculaciones',
          },
          {
            label: 'Clubes',
            icon: 'pi pi-fw pi-users',
            routerLink: '/gestor/clubes',
          },
        ],
      },

      [environment.roles.adminRole]: {
        label: 'Configuración',
        icon: 'pi pi-fw pi-sitemap',
        routerLink: '/admin',
        items: [
          {
            label: 'Productos & Servicios',
            icon: 'pi pi-fw pi-dollar',
            routerLink: '/admin/productos-servicios',
          },
        ],

        
        router: {
          path: '/admin',
        },
      },

      [environment.roles.gestionEventosRole]: {
        label: 'Gestión Eventos',
        icon: 'pi pi-fw pi-calendar',
        routerLink: '/event-gestor',
        items: [
          {
            label: 'Eventos',
            icon: 'pi pi-fw pi-calendar-plus',
            routerLink: 'event-gestor/events',
          }
        ],
        router: {
          path: '/event-gestor',
        },
      },

      [environment.roles.financialGestorRole]: {
        label: 'Gestión Financiera',
        icon: 'pi pi-fw pi-money-bill',
        routerLink: '/financial-gestor',
        items: [
          {
            label: 'Eventos',
            icon: 'pi pi-fw pi-calendar-plus',
            routerLink: 'financial-gestor/events',
          },
          {
            label: 'Vinculaciones',
            icon: 'pi pi-users pi-calendar-plus',
            routerLink: 'financial-gestor/vinculaciones',
          }
        ],
        router: {
          path: '/financial-gestor',
        },
      },

      [environment.roles.checkerRole]: {
        label: 'Gestión de Accesos',
        icon: 'pi pi-fw pi-sign-in',
        routerLink: 'checker',
        items: [
          {
            label: 'Check-in Alumnos',
            icon: 'pi pi-fw pi-qrcode',
            routerLink: 'checker/checkin',
          },
          // {
          //   label: 'Consulta de Alumnos',
          //   icon: 'pi pi-fw pi-search',
          //   routerLink: 'checker/checkerFind',
          // }
        ],
        router: {
          path: '/checker',
        },
      },
    };
    this.userLoggedOptions = [
      {
        label: 'Cerrar Sesión',
        icon: 'pi pi-fw pi-power-off',
        command: () => {
          this.logout();
        },
      },
    ];


  }

  loadMenuByUserRole() {
    this.menuRol.push({
      label: 'Inicio',
      icon: 'pi pi-fw pi-home',
      routerLink: '/home',
    });

    for (let rol of this.userRoles) {
      if(this.items[rol]){
        this.menuRol.push(this.items[rol]);
      }
    }
  }
  loguin(event: any) {
    this.loginRequest.emit(true);
  }

  logout(popup?: boolean) {
    if (popup) {
      this.msalService.logoutPopup({
        mainWindowRedirectUri: '/',
      });
    } else {
      this.msalService.logoutRedirect();
    }
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  closeMobileMenu() {
    this.mobileMenuOpen = false;
  }
}
